import { useMemo } from 'react';

import type { Task } from '../../services/taskService';
import { useGetTasksQuery } from '../../store/services/tasksApi';

interface TaskSummary {
  hasTodoTasks: boolean;
  todoTaskCount: number;
  hasErrorTasks: boolean;
  activeTask: Task | null;
}

const EMPTY_SUMMARY: TaskSummary = {
  hasTodoTasks: false,
  todoTaskCount: 0,
  hasErrorTasks: false,
  activeTask: null,
};

const summarizeTasks = (tasks: Task[] | undefined): TaskSummary => {
  if (!tasks) return EMPTY_SUMMARY;
  const workspaceTasks = tasks.filter((task) => task.task_type !== 'planning');
  const todos = workspaceTasks.filter((task) => (
    ['todo', 'queued', 'ai_in_progress', 'human_in_progress'].includes(task.status)
  ));

  return {
    hasTodoTasks: todos.length > 0,
    todoTaskCount: todos.length,
    hasErrorTasks: workspaceTasks.some((task) => task.status === 'error'),
    activeTask: workspaceTasks.find((task) => task.status === 'ai_in_progress') ?? null,
  };
};

export const useChatBoxTasks = (projectId: string | null): TaskSummary => {
  const selectSummary = useMemo(() => (
    ({ currentData }: { currentData?: Task[] }) => summarizeTasks(currentData)
  ), []);

  return useGetTasksQuery(projectId ?? '', {
    skip: !projectId,
    selectFromResult: selectSummary,
  });
};
